import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';

const Radio = ({ options, value, style, onChange, disabled, givenKey }) => {
  const [selected, setSelected] = useState(value?.id);

  const { t } = useTranslation();

  // Atualiza o estado local quando o valor externo muda
  useEffect(() => {
    setSelected(value?.id);
  }, [value]);

  const handleRadioSelect = (value) => {
    setSelected(value);
    onChange({ target: { value: value } });
  };

  return (
    <div className='radio-input-container' style={style} key={givenKey}>
      {options.map((option, index) => (
        <label key={index} className='radio-item'>
          <input
            type='radio'
            name={`radio-group-${givenKey}`}
            value={option.id}
            checked={selected === option.id}
            onChange={() => handleRadioSelect(option.id)}
            disabled={disabled}
          />
          <span>{option.label}</span>
        </label>
      ))}
    </div>
  );
};

export default Radio;
